// extracted by mini-css-extract-plugin
export default {"identityProvidersTable":"identity-providers-table-container__identity-providers-table__d4vim"};